import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import { CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import './style.scss';

interface Image {
    resource: string;
}

interface CarouselImageModalProps {
    visible: boolean;
    images: Image[];
    initialIndex: number;
    onClose: () => void;
}

export const CarouselImageModal: React.FC<CarouselImageModalProps> = ({
    visible,
    images,
    initialIndex,
    onClose,
}) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    useEffect(() => {
        setCurrentIndex(initialIndex);
    }, [initialIndex, visible]);

    if (!images || images.length === 0) return null;

    return (
        <div className="ant-modal-media_gallery">
            <Modal
                wrapClassName="ant-modal-media_gallery__wrap"
                visible={visible}
                onCancel={onClose}
                footer={null}
                width="100vw"
                centered
                bodyStyle={{ padding: 0, height: "100vh", background: "rgba(0,0,0,0.95)" }}
                closeIcon={<CloseOutlined style={{ color: "#fff", fontSize: "24px" }} />}
                className="media-gallery-modal"
            >
                <div className="media-gallery-layout">
                    <div className="main-preview">
                        <Button
                            className="nav-btn prev"
                            icon={<LeftOutlined />}
                            onClick={() =>
                                setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)
                            }
                        />

                        <div className="image-wrapper">
                            <img src={images[currentIndex]?.resource} alt="Preview" />
                        </div>

                        <Button
                            className="nav-btn next"
                            icon={<RightOutlined />}
                            onClick={() =>
                                setCurrentIndex((prev) => (prev + 1) % images.length)
                            }
                        />

                        <div className="counter">
                            {currentIndex + 1} / {images.length}
                        </div>
                    </div>

                    <div className="thumbnails-bar">
                        {images.map((img, idx) => (
                            <div
                                key={idx}
                                className={`thumb-item ${idx === currentIndex ? "active" : ""}`}
                                onClick={() => setCurrentIndex(idx)}
                            >
                                <img src={img.resource} alt={`Thumb ${idx}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>

        </div>

    );
};
